export default {
  common: {
    error: "エラーが発生しました",
    reload: "再読み込み",
    errorNotification: "問題を確認し、できるだけ早く修正いたします。問題が続く場合は、",
    contactUs: "お問い合わせください。",
    language: "言語",
    loading: "読み込み中...",
    loadingText: "読み込み中",
    save: "保存",
    savedSuccessfully: "正常に保存されました",
    saving: "保存中...",
    cancel: "キャンセル",
    edit: "編集",
    delete: "削除",
    add: "追加",
    search: "検索",
    filter: "フィルター",
    clear: "クリア",
    preview: "プレビュー",
    default: "デフォルト: {{value}}",
    optional: "オプション",
    required: "必須",
    noData: "データがありません",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "店舗",
      cities: "都市", 
      regions: "地域",
      countries: "国",
      showOnMap: "地図に表示",
      addLocation: "店舗を追加"
    },
    welcome: {
      title: "Locations So Superへようこそ。",
      subtitle: "ナビゲーションからセクションを選択して開始してください。"
    }
  },

  // Cities section
  cities: {
    title: "都市",
    resourceSingular: "都市",
    resourcePlural: "都市",
    headings: {
      name: "名前",
      status: "ステータス",
      locations: "店舗", 
      region: "地域",
      country: "国"
    },
    breadcrumbs: {
      cities: "都市"
    }
  },

  // Countries section  
  countries: {
    title: "国",
    resourceSingular: "国", 
    resourcePlural: "国",
    headings: {
      name: "名前",
      status: "ステータス",
      locations: "店舗",
      cities: "都市",
      regions: "地域"
    },
    breadcrumbs: {
      countries: "国"
    }
  },

  // Regions section
  regions: {
    title: "地域",
    resourceSingular: "地域",
    resourcePlural: "地域", 
    headings: {
      name: "名前",
      status: "ステータス",
      locations: "店舗",
      cities: "都市",
      country: "国"
    },
    breadcrumbs: {
      regions: "地域"
    }
  },

  // Map section
  map: {
    title: "地図",
    breadcrumbs: {
      locations: "店舗"
    }
  },

  // Import section
  import: {
    title: "CSVインポート",
    breadcrumbs: {
      locations: "店舗"
    },
    new: {
      title: "CSVで店舗をインポート",
      description: "サンプルCSVテンプレートをダウンロードして、必要な形式の例を確認してください",
      sampleTemplate: "サンプルCSVテンプレート",
      uploadAndContinue: "アップロードして続行",
      abortOnError: "エラー時に中止",
      abortOnErrorHelp: "エラーがある場合、インポートは中止され、エラーが表示され、店舗はインポートされません。",
      needHelp: "店舗のインポートについてサポートが必要ですか？"
    },
    show: {
      title: "CSVインポート",
      youCanLeavePage: "このページを離れることができます",
      backgroundMessage: "インポートはバックグラウンドで実行され続けます",
      importProgress: "インポート進捗",
      imported: "インポート済み",
      suffix: "店舗",
      importLog: "インポートログ",
      cancelImport: "インポートをキャンセル",
      cancelConfirmation: {
        title: "インポートをキャンセル",
        message: "このインポートジョブをキャンセルしてもよろしいですか？この操作は元に戻せません。",
        note: "注意：進行中のジョブの場合、ジョブは完了する必要があり、完了直後に削除されます。",
        yesCancel: "はい、インポートをキャンセル",
        noContinue: "いいえ、インポートを続行"
      },
      report: "レポート",
      failedLocations: "失敗した店舗",
      uploadAnother: "別のCSVをアップロード",
      backToLocations: "店舗に戻る",
      importSucceeded: "インポート成功",
      importFailed: "インポート失敗"
    },
    messages: {
      uploadSuccess: "CSVのアップロードに成功しました",
      uploadError: "CSVをアップロードできませんでした",
      pending: "インポートがまだ開始されていません",
      inProgress: "インポート進行中",
      completed: "インポート完了",
      invalidHeader: "以下の列が必要です",
      invalidCsvFile: "無効なCSVファイル",
      aborted: "インポート中止",
      failed: "インポート失敗",
      cancelled: "インポートキャンセル"
    },
    errors: {
      csvTooLarge: "CSVが大きすぎます",
      languageNotEnabled: "言語 '{{language}}' がこのストアで有効になっていません。まず設定 > 言語で有効にしてください。",
      fieldNotTranslatable: "フィールド '{{field}}' は翻訳できません。翻訳可能なフィールドは {{fields}} です",
      locationError: "スラッグ付きロケーション: {{slug}} - {{error}}",
      planLimit: "ロケーションのプラン制限に達しています"
    }
  },

  // Location form
  location: {
    index: {
      title: "店舗",
      addLocation: "店舗を追加",
      import: "インポート",
      noPrioritySet: "優先度未設定",
      published: "公開済み",
      draft: "下書き",
      resourceSingular: "店舗",
      resourcePlural: "店舗",
      headings: {
        name: "名前",
        status: "ステータス", 
        city: "都市",
        region: "地域",
        country: "国",
        priority: "優先度"
      }
    },
    form: {
      title: "店舗を追加",
      editTitle: "店舗を編集",
      basicInformation: "基本情報",
      name: "名前",
      namePlaceholder: "例：ブライアンのレンガ店",
      nameHelpDefault: "デフォルト: {{defaultName}}",
      details: "詳細",
      description: "説明",
      descriptionPlaceholder: "この店舗の特徴を顧客に伝えてください",
      address: "住所",
      addressPlaceholder: "123 メインストリート、都市、国",
      addressLine1: "住所1行目",
      addressLine2: "住所2行目",
      postalZipCode: "郵便番号 / ZIPコード",
      city: "都市",
      stateProvinceRegion: "州 / 県 / 地域",
      country: "国",
      phone: "電話番号",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "メールアドレス", 
      emailPlaceholder: "store@example.com",
      website: "ウェブサイト",
      websitePlaceholder: "https://www.example.com",
      image: "画像",
      imagePlaceholder: "画像URLを入力",
      status: "ステータス",
      statusActive: "アクティブ",
      statusInactive: "非アクティブ",
      statusDraft: "下書き",
      priority: "優先度",
      priorityHelpText: "優先度の高い店舗が検索結果の最初に表示されます",
      findOnMapButton: "地図で探す"
    },
    validation: {
      addressNotFound: "住所が見つかりませんでした",
      createSuccess: "店舗が正常に作成されました", 
      updateSuccess: "店舗が正常に更新されました",
      checkFields: "フィールドを確認してください",
      findOnMap: "保存する前に地図で店舗を見つけてください"
    },
    errors: {
      loading: "店舗の読み込みエラー"
    },
    actions: {
      save: "店舗を保存",
      delete: "店舗を削除",
      preview: "プレビュー"
    },
    customFields: {
      title: "カスタムフィールド",
      noCustomFields: "カスタムフィールドが設定されていません",
      configureFields: "フィールドを設定",
      emptyState: "まだカスタムフィールドを設定していません。カスタムフィールドを使用すると、ビジネスニーズに特化した追加情報を追加できます。"
    },
    openingHours: {
      title: "営業時間",
      checkboxLabel: "この店舗には営業時間と閉店時間があります",
      statusOpen: "営業中",
      statusOpen24h: "24時間営業",
      statusClosed: "閉店",
      openingTimeLabel: "開店時間",
      closingTimeLabel: "閉店時間",
      days: {
        monday: "月曜日",
        tuesday: "火曜日", 
        wednesday: "水曜日",
        thursday: "木曜日",
        friday: "金曜日",
        saturday: "土曜日",
        sunday: "日曜日"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "最近追加",
        recentlyModified: "最近変更"
      },
      filters: {
        status: "ステータス",
        taggedWith: "タグ付き",
        locationStatus: "店舗ステータス",
        noTagsToShow: "表示するタグがありません",
        searchPlaceholder: "検索"
      },
      bulkActions: {
        setPublished: "公開済みに設定",
        setUnpublished: "非公開に設定", 
        setPriority: "優先度を設定",
        deleteLocations: "店舗を削除",
        exportCSV: "CSVとしてエクスポート"
      },
      appliedFilters: {
        statusIs: "ステータスは {{status}}",
        taggedWith: "{{tag}} でタグ付け",
        nameIncludes: "名前に {{search}} を含む"
      },
      modals: {
        deleteTitle: "店舗を削除",
        deleteMessage: "{{count}} を削除してもよろしいですか？",
        deleteMessageAll: "すべての店舗を削除してもよろしいですか？",
        prioritiseTitle: "{{count}} 店舗の優先度を設定",
        prioritiseTitleAll: "すべての店舗の優先度を設定",
        delete: "削除",
        cancel: "キャンセル"
      },
      emptyState: {
        noResultsHeading: "{{resourcePlural}} が見つかりませんでした",
        noResultsText: "フィルターや検索語を変更してみてください",
        noDataHeading: "{{resourcePlural}} を追加してください",
        addLocation: "店舗を追加",
        importFromCSV: "CSVからインポート"
      },
      pagination: {
        label: "{{page}} / {{pages}} ページ"
      },
      messages: {
        updatedSuccessfully: "正常に更新されました",
        deletedSuccessfully: "正常に削除されました", 
        exportedSuccessfully: "正常にエクスポートされました",
        error: "問題が発生しました"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "ページコンテンツ",
    editTemplate: "SEOテンプレートを編集", 
    pageTitle: "タイトル",
    pageDescription: "説明",
    metaTitle: "タイトル",
    metaDescription: "説明",
    urlHandle: "URLハンドル",
    searchEnginePreview: "検索エンジン表示プレビュー",
    editMeta: "メタを編集",
    previewMeta: "メタをプレビュー",
    loading: "読み込み中...",
    editingLocaleHelp: "{{locale}} コンテンツを編集中。"
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEOテンプレート",
    breadcrumbs: {
      seoTemplates: "SEOテンプレート"
    },
    template: {
      title: "{{templateName}} テンプレート - {{locale}}",
      discardChanges: "変更を破棄"
    },
    form: {
      pageContent: "ページコンテンツ",
      searchEnginePreview: "検索エンジン表示プレビュー",
      title: "タイトル",
      description: "説明",
      pageTitle: "ページタイトル",
      metaDescription: "メタ説明",
      editingLocaleHelp: "{{locale}} 翻訳を編集中。空のフィールドは {{defaultLocale}} のコンテンツを表示します。",
      defaultValue: "デフォルト: {{value}}"
    },
    language: {
      label: "言語",
      defaultHelp: "これはあなたのデフォルト言語です",
      editingHelp: "{{locale}} 翻訳を編集中。空のフィールドは {{defaultLocale}} コンテンツを表示します。"
    },
    banner: {
      multipleLanguagesDisabled: "多言語が有効になっていません",
      enableInSettings: "設定で有効にする",
      multipleLanguagesInfo: "複数の言語でSEOテンプレートを管理するには、言語設定で国際化を有効にしてください。現在は {{locale}} テンプレートのみを表示しています。"
    },
    badges: {
      errors: "エラー！",
      unsaved: "未保存"
    },
    messages: {
      saveSuccess: "SEOテンプレートが正常に保存されました",
      saveError: "テンプレートを保存できませんでした",
      error: "エラー..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "基本情報",
      name: "名前",
      save: "保存",
      saving: "保存中...",
      cancel: "キャンセル",
      yourLocationsIn: "{{name}} の店舗",
      tableHeadings: {
        name: "名前",
        status: "ステータス",
        city: "都市",
        region: "地域",
        country: "国"
      },
      resourceName: {
        singular: "{{name}} の店舗",
        plural: "{{name}} の店舗"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "地図",
      tags: "タグ",
      customFields: "カスタムフィールド",
      languages: "言語",
      plan: "プラン",
      addTag: "タグを追加",
      addField: "フィールドを追加"
    },
    planBadges: {
      trial: "！",
      endsSoon: "まもなく終了"
    },
    common: {
      loading: "読み込み中...",
      error: "エラー...",
      breadcrumbs: {
        settings: "設定"
      },
      skeleton: {
        customFields: "カスタムフィールド",
        addField: "フィールドを追加",
        name: "名前",
        contentType: "コンテンツタイプ",
        usedIn: "使用場所",
        field: "フィールド",
        fields: "フィールド"
      },
      messages: {
        savedSuccessfully: "{{setting}} 設定が正常に保存されました",
        couldntSave: "{{setting}} 設定を保存できませんでした"
      }
    },
    map: {
      title: "地図",
      messages: {
        savedSuccessfully: "地図設定が正常に保存されました",
        couldntSave: "設定を保存できませんでした"
      },
      mapboxToken: {
        title: "Mapboxトークン",
        description: "店舗検索を動作させるためにMapboxトークンを入力してください",
        label: "Mapboxトークン",
        placeholder: "地図を継続して使用するには、ここにトークンを入力してください。",
        placeholderManaged: "無料のマップロードを使い切ったら、地図を継続して使用するためにここにトークンを入力してください。",
        helpText: "Mapboxキーの作成手順に従って、キーを上記に貼り付けてください。問題が発生した場合は、サポートにお問い合わせください。",
        linkInstructions: "Mapboxキーの作成手順",
        linkSupport: "サポートにお問い合わせ"
      },
      managedToken: {
        title: "マップロード",
        description: "管理されたトークンで最大 {{max}} 回の無料マップロードがあります。その後は独自のトークンを作成する必要があります。"
      },
      appearance: {
        title: "外観",
        description: "地図の視覚的な外観を変更"
      },
      mapStyle: {
        title: "地図スタイル",
        options: {
          streets: "ストリート",
          outdoors: "アウトドア", 
          light: "ライト",
          dark: "ダーク",
          satellite: "衛星",
          satelliteStreets: "衛星ストリート",
          navigationDay: "ナビゲーション（昼）",
          navigationNight: "ナビゲーション（夜）"
        }
      },
      searchBehaviour: {
        title: "検索動作",
        description: "訪問者が地図上で店舗を見つける方法を制御します。",
        geolocateLabel: "訪問者の位置を自動推定して近くの店舗を表示",
        geolocateHelp: "位置情報の取得が成功した場合、地図は訪問者の近くに移動します。推定位置が見つからない場合、地図は開始位置のままになります。",
        filterBehaviour: {
          title: "フィルター動作",
          all: {
            label: "すべてのタグ",
            help: "店舗がフィルターに表示されるには、選択されたすべてのタグが必要です"
          },
          any: {
            label: "いずれかのタグ", 
            help: "店舗がフィルターに表示されるには、選択されたタグのいずれかがあれば十分です"
          }
        },
        keepSearchInView: {
          label: "検索マーカーを表示範囲内に保持",
          help: "検索結果が表示されると、地図はズームアウトしてすべての一致する店舗を表示します"
        },
        distanceUnits: {
          title: "距離単位",
          km: "キロメートル",
          miles: "マイル"
        },
        maxResults: {
          label: "最大結果数",
          help: "検索結果に表示される店舗数を制限",
          options: {
            results30: "30件の結果"
          }
        },
        maxDistance: {
          label: "最大距離", 
          help: "検索ポイントからこの距離内の店舗のみを表示",
          options: {
            unlimited: "無制限"
          }
        },
        showLocationNames: {
          label: "提案に店舗名を表示",
          help: "検索提案に店舗名を表示"
        },
        sortByPriority: {
          label: "距離ではなく優先度で並べ替え",
          help: "このボックスがチェックされている場合は、最大距離（無制限以外）を設定することを強く推奨します。そうしないと、お客様は合理的な距離内にある店舗よりも、遠くにあるが優先度の高い店舗が上位に表示されることになります。"
        }
      },
      searchResults: {
        title: "検索結果",
        description: "地図上で店舗が返される方法を制御します。",
        locationsLabel: "検索結果テキスト",
        locationsHelp: "検索結果の上に表示されるテキスト（例：「5件の店舗を表示」）",
        prefixLabel: "検索結果プレフィックス", 
        prefixHelp: "結果数の前に表示されるテキスト"
      },
      popups: {
        title: "ポップアップ",
        showPopups: {
          label: "ポップアップを表示",
          help: "訪問者が地図マーカーをクリックしたときに店舗の詳細を表示"
        }
             },
       whitelabel: {
         title: "ホワイトラベル",
         hideLabel: "Powered by テキストを非表示",
         hideHelp: "店舗検索から私たちのブランディングを削除"
       }
    },
    languages: {
      title: "言語",
      error: "エラー...",
      messages: {
        savedSuccessfully: "言語設定が正常に保存されました",
        couldntSave: "言語設定を保存できませんでした"
      },
      banner: {
        upgradeTitle: "多言語サポートにはプランアップグレードが必要です",
        upgradeAction: "Superestにアップグレード",
        upgradeMessage: "デフォルト言語は変更できますが、複数の言語を有効にするにはアップグレードが必要です。",
        disabledMessage: "現在のプランでは多言語設定が無効になっています"
      },
      defaultLanguage: {
        title: "デフォルト言語", 
        description: "コンテンツが表示される主要言語を選択してください。",
        label: "デフォルト言語",
        help: "特定の言語が要求されない場合、この言語が使用されます"
      },
      internationalization: {
        title: "国際化",
        description: "複数の言語を有効にします。より多くの顧客にリーチし、SEOを向上させます。",
        enableLabel: "複数の言語を有効にする",
        enableHelp: "顧客が異なる言語で店舗検索を表示できるようにする"
      },
      supportedLanguages: {
        title: "追加でサポートする言語",
        description: "サポートしたい追加の言語を選択してください。言語を有効にすると、アプリ全体で翻訳を提供するオプションが表示されます。サポートされている言語の場合、デフォルトのSEOテンプレートと共通の変数テーマが自動的に生成されます。",
        defaultLocaleNote: "これはあなたのデフォルト言語で、無効にすることはできません",
        shopifyEnabled: {
          label: "この言語は私のShopifyストアで有効になっています",
          importantNote: "重要：",
          description: "この言語がShopifyストアで有効になっておらず、公開されていない場合は、上記のボックスのチェックを外してください。まだ行っていない場合は、よりスムーズな顧客体験のために、まずShopify管理画面の設定 > 言語でShopifyストアの言語を有効にすることをお勧めします。"
        },
        urlFormats: {
          cleanUrls: "クリーンURL：",
          betterSeo: "より良いSEOとユーザーエクスペリエンス",
          queryUrls: "クエリパラメータURL：",
          considerEnabling: "より良いURLのためにShopifyで有効にすることを検討"
        },
        preview: {
          button: "プレビュー",
          tooltip: "{{language}} 店舗検索をプレビュー"
        },
        tooltips: {
          noTemplates: "この言語のデフォルトSEOテンプレートは利用できません。カスタム翻訳を簡単に作成できます。"
        }
      }
    },
    tags: {
      title: "タグ",
      addTag: "タグを追加",
      error: "エラー",
      messages: {
        deletedSuccessfully: "タグが正常に削除されました",
        couldntDelete: "タグを削除できませんでした",
        savedSuccessfully: "タグが正常に保存されました",
        couldntSave: "フィールドを確認してください",
        tagDeleted: "タグが正常に削除されました"
      },
      resourceName: {
        singular: "タグ",
        plural: "タグ"
      },
      filters: {
        anyGroup: "任意のグループ",
        inGroup: "グループ内",
        tagGroup: "タググループ"
      },
      appliedFilters: {
        inGroup: "{{group}} グループ内",
        nameContains: "タグ名に {{query}} を含む"
      },
      bulkActions: {
        deleteTag: "タグを削除",
        deleteTags: "タグを削除"
      },
      form: {
        language: "言語",
        title: "タイトル",
        description: "説明",
        group: "グループ",
        groupPlaceholder: "グループを選択",
        addGroup: "追加",
        editingTranslations: "{{language}} 翻訳を編集中。空のフィールドは {{defaultLanguage}} のコンテンツを表示します。",
        defaultValue: "デフォルト: {{value}}",
        image: "画像",
        imageUrl: "画像URL"
      },
      actions: {
        save: "保存",
        deleteTag: "タグを削除"
      },
      new: {
        title: "タグを追加",
        messages: {
          createSuccess: "タグが正常に作成されました",
          checkFields: "フィールドを確認してください"
        },
        actions: {
          createTag: "タグを作成"
        }
      }
    },
    customFields: {
      title: "カスタムフィールド",
      addField: "フィールドを追加",
      error: "エラー",
      resourceName: {
        singular: "フィールド",
        plural: "フィールド"
      },
      headings: {
        name: "名前",
        contentType: "コンテンツタイプ",
        usedIn: "使用場所"
      },
      emptyState: {
        heading: "カスタムフィールドを作成・管理",
        createAction: "フィールドを作成",
        description: "カスタムフィールドを使用して、店舗に関する独自の属性を追加します。これらのフィールドは、ソーシャルプロフィールから店舗管理者の名前とメールアドレスまで何でも可能です"
      },
      pluralization: {
        location: "店舗",
        locations: "店舗"
      },
      form: {
        name: "名前",
        contentType: "コンテンツタイプ",
        key: "キー",
        keyPrefix: "location.fields.",
        keyHelp: "このキーを使用して、liquidテンプレートで店舗の {{name}} コンテンツにアクセスします。",
        translations: {
          title: "翻訳",
          showTranslations: "翻訳を表示",
          hideTranslations: "翻訳を非表示",
          description: "翻訳はオプションです。空のフィールドは {{language}} フィールド名を表示します。",
          nameTranslation: "名前 ({{language}})",
          defaultValue: "デフォルト: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "フィールドが正常に保存されました",
        couldntSave: "フィールドを保存できませんでした",
        deletedSuccessfully: "フィールドが正常に削除されました",
        couldntDelete: "フィールドを削除できませんでした"
      },
      actions: {
        delete: "削除"
      },
      new: {
        title: "フィールドを追加",
        messages: {
          savedSuccessfully: "フィールドが正常に保存されました",
          couldntSave: "フィールドを保存できませんでした"
        }
      },
      contentTypes: {
        text: "テキスト",
        textArea: "テキストエリア", 
        email: "メールアドレス",
        number: "数値",
        phoneNumber: "電話番号",
        time: "時間",
        url: "URL"
      }
    },
    plan: {
      title: "プラン",
      error: "エラー",
      changePlan: "プランを変更",
      usdPerMonth: "USD / 月",
      sections: {
        yourPlanIncludes: "あなたのプランには以下が含まれます",
        nextBillingDate: "次回請求日",
        trial: "トライアル"
      },
      banners: {
        planUpdated: "プランが更新されました",
        thankYouUpgrading: "アップグレードありがとうございます！",
        letUsKnow: "お知らせください",
        improvementText: "改善できることがあれば。",
        trialCancellation: {
          title: "トライアルキャンセル通知",
          message: "有料プランにアップグレードすると、14日間の無料トライアルはキャンセルされます。"
        }
      },
      locations: {
        upTo: "最大",
        locations: "店舗",
        unlimited: "無制限の店舗",
        used: "使用済み",
        ofUsed: "{{used}} / {{max}} 使用済み"
      },
      trial: {
        daysLeft: "残り {{days}} 日",
        daysUsed: "{{used}} / {{total}} 日使用済み",
        selectPlan: "プランを選択",
        currentPlan: "現在のプラン",
        trialBadge: "トライアル",
        currentBadge: "現在",
        yourTrialJustStarted: "トライアルが始まったばかりです",
        trialEndsAfterToday: "トライアルは今日で終了します",
        trialEndsTomorrow: "トライアルは明日終了します",
        daysLeftInTrial: "トライアル残り {{days}} 日",
        continueAddingLocations: "{{date}} 以降も店舗を追加し続けるにはプランを選択してください",
        selectPlanToday: "店舗の追加を続けるには今日プランを選択してください"
      },
      footer: {
        description: "Locations So Superプランを管理または変更します。",
        termsOfService: "利用規約",
        and: "および",
        privacyPolicy: "プライバシーポリシー"
      },
      features: {
        analytics: {
          title: "分析",
          description: "人々がどのように店舗を使用し、どこを検索しているかを調べる"
        },
        internationalization: {
          title: "多言語サポート",
          description: "複数の言語を有効にしてSEOを向上させ、ターゲット市場でより多くの顧客にリーチ"
        },
        customThemes: {
          editLiquid: {
            title: "テーマliquidテンプレートを編集",
            description: "テーマliquidにアクセスして、好きな方法で店舗データを表示"
          },
          editStructuredData: {
            title: "ビジネス構造化データを編集",
            description: "構造化データを編集してGoogleがページを理解する方法を編集"
          }
        }
      },
      edit: {
        title: "プランを変更",
        allPlansInclude: "上記のすべてのプランには以下が含まれます",
        needingMoreLocations: "より多くの店舗が必要ですか？",
        footerQuestion: "始める前に質問がありますか？",
        sendMessage: "メッセージを送信",
                  allFeatures: {
            seoDirectory: {
              title: "SEOディレクトリとランディングページ",
              description: "すべての店舗、都市、地域のSEOディレクトリを自動的に作成"
            },
            mapPage: {
              title: "検索とフィルター付きマップページ",
              description: "Mapboxで動作する地図で店舗を検索・フィルター"
            },
            tags: {
              title: "タグ",
              description: "画像と説明付きのタグを作成してグループ化"
            },
            openingHours: {
              title: "営業時間",
              description: "店舗の営業時間を設定・表示"
            },
            mapStyles: {
              title: "マップスタイル",
              description: "プリセットスタイルでマップの外観を変更"
            },
            customFields: {
              title: "カスタムフィールド",
              description: "ソーシャルリンクから店舗管理者まで、必要な新しいフィールドを追加"
            },
            csvUpload: {
              title: "CSVでのアップロードとエクスポート",
              description: "店舗をアップロード・一括編集"
            },
            richSnippets: {
              title: "リッチスニペット",
              description: "ローカルビジネス構造化データでGoogleがページをより良く理解するのを支援"
            },
            directionsAndCalls: {
              title: "道案内と電話",
              description: "訪問者は簡単に道案内を取得し、店舗に電話をかけることができます"
            },
            languageSupport: {
              title: "言語サポート",
              description: "デフォルト言語を英語以外に変更。32の主要言語の翻訳テンプレートが簡単なセットアップのために提供されています。"
            }
          }
      },
      planCard: {
        bestToCustomize: "カスタマイズに最適",
        currentPlan: "現在のプラン",
        chooseThisPlan: "このプランを選択",
        locationsSection: "店舗",
        featuresSection: "機能",
        upTo: "最大",
        locations: "店舗",
        tooltipTooManyLocations: "このプランに対して店舗や有効な言語が多すぎます。"
      },
      confirmation: {
        error: "プラン確認エラー"
      }
    }
  },

  // Themes section
  themes: {
    title: "テーマ",
    currentTheme: {
      title: "現在のテーマ",
      description: "これは顧客が店舗アプリを訪問したときに見るテーマです。"
    },
    themeLibrary: {
      title: "テーマライブラリ", 
      description: "店舗テーマを管理します。テーマを追加・公開してオンライン店舗の外観を変更します。"
    },
    skeleton: {
      currentThemeDescription: "これは顧客が店舗アプリを使用したときに見るテーマです。"
    },
    modal: {
      overrideTitle: "現在のテーマを上書きしますか？",
      override: "上書き",
      cancel: "キャンセル",
      undoWarning: "この操作は元に戻せません。"
    },
    messages: {
      publishSuccess: "テーマが正常に公開されました",
      publishError: "テーマを公開できませんでした",
      error: "エラーが発生しました"
    },
    emptyStates: {
      settings: {
        heading: "このテーマには設定がありません",
        description: "テンプレートエディターで設定を作成します。",
        createSettings: "設定を作成",
        upgradePlan: "プランをアップグレード",
        upgradeRequired: "設定を作成するにはプランをアップグレード"
      },
      language: {
        heading: "このテーマには言語用語がありません",
        description: "テンプレートエディターで言語用語を作成します。",
        createLanguageTerms: "言語用語を作成",
        upgradePlan: "プランをアップグレード",
        upgradeRequired: "言語用語を作成するにはプランをアップグレード"
      }
    },
    templates: {
      categories: {
        templates: "テンプレート",
        schemas: "スキーマ",
        styles: "スタイル",
        liquidReference: "Liquidリファレンス"
      },
      items: {
        landing: "ランディング",
        directory: "ディレクトリ",
        country: "国",
        region: "地域",
        city: "都市",
        location: "店舗",
        language: "言語",
        settings: "設定",
        stylesheet: "スタイルシート"
      },
      errors: {
        errorsInTemplate: "テンプレートのエラー",
        error: "エラー"
      },
      badges: {
        errors: "エラー！",
        unsaved: "未保存"
      },
      actions: {
        viewTheme: "テーマを表示",
        discard: "破棄",
        save: "保存"
      }
    },
    language: {
      messages: {
        saveSuccess: "テーマ言語翻訳が正常に保存されました",
        saveError: "テーマを保存できませんでした"
      },
      form: {
        language: "言語",
        defaultLanguageHelp: "これはあなたのデフォルト言語です",
        translationHelp: "{{selectedLocale}} の翻訳を編集中。空のフィールドは {{defaultLocale}}（あなたのデフォルト言語）のコンテンツを表示します。"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "複数の言語が有効になっていません",
          action: "設定で有効にする",
          description: "複数の言語の翻訳を管理するには、言語設定で国際化を有効にしてください。現在 {{locale}} 翻訳のみを表示しています。"
        },
        translating: {
          title: "{{from}} から {{to}} に翻訳中",
          description: "空のままにしたフィールドは、顧客に {{defaultLocale}} コンテンツを自動的に表示します。{{selectedLocale}} で異なるコンテンツを希望するフィールドのみ翻訳してください。"
        }
      },
      accessLanguageTerms: "liquidで {{code}} を使用して {{category}} 言語用語にアクセス",
      fields: {
        // Common language fields - add specific ones as needed
        title: "タイトル",
        description: "説明",
        heading: "見出し",
        subheading: "サブ見出し",
        button_text: "ボタンテキスト",
        link_text: "リンクテキスト",
        placeholder: "プレースホルダー",
        label: "ラベル",
        help_text: "ヘルプテキスト",
        error_message: "エラーメッセージ",
        success_message: "成功メッセージ",
        
        // Opening hours
        Monday: "月曜日",
        Tuesday: "火曜日",
        Wednesday: "水曜日",
        Thursday: "木曜日",
        Friday: "金曜日",
        Saturday: "土曜日",
        Sunday: "日曜日",
        opening_hours_format: "営業時間フォーマット",
        closes_at_format: "閉店時間フォーマット",
        opens_at_format: "開店時間フォーマット",
        opens_on: "開店日",
        open_24h: "24時間営業",
        open: "営業中",
        closed: "閉店",
        closes_at: "閉店時間",
        opens_at: "開店時間",
        
        // Map
        search_map: "マップを検索",
        search_area: "このエリアを検索",
        view_map: "マップ",
        view_list: "リスト",
        open_filters: "フィルター",
        stores_near_you: "近くの店舗",
        header: "店舗を探す！",
        search_placeholder: "郵便番号または住所を入力...",
        no_listings: "申し訳ございませんが、検索に一致する店舗が見つかりません。フィルターまたは検索場所を変更してみてください",
        
        // Directory
        view_directory: "店舗ディレクトリ",
        
        // Location
        get_directions: "道案内",
        call: "電話",
        view_website: "ウェブサイト",
        email: "メール",
        opening_hours_header: "営業時間",
        description_header: "情報",
        phone_number_header: "電話番号",
        address_header: "住所",
        tag_groups_to_display: "表示するタググループ"
      },
              categories: {
          // Common language categories - add specific ones as needed
          general: "一般",
          navigation: "ナビゲーション",
          forms: "フォーム",
          buttons: "ボタン",
          messages: "メッセージ",
          errors: "エラー",
          opening_hours: "営業時間",
          map: "マップ",
          directory: "ディレクトリ",
          location: "店舗"
        }
    },
    settings: {
      messages: {
        saveSuccess: "テーマが正常に保存されました",
        saveError: "テーマを保存できませんでした"
      },
      accessSettings: "liquidで {{code}} を使用して {{category}} 設定にアクセス",
      fields: {
        // Colors
        color_text: "テキスト色",
        color_text_heading: "見出しテキスト色", 
        color_background: "背景色",
        color_accent: "アクセント色",
        color_text_positive: "ポジティブテキスト色",
        color_text_negative: "ネガティブテキスト色",
        dark_theme: "ダークテーマ",
        color_marker: "マーカー色",
        color_search_marker: "検索マーカー色",
        
        // Typography
        base_font_size: "基本フォントサイズ",
        
        // Buttons
        border_radius: "ボーダー半径",
        
        // Images
        aspect_ratio: "アスペクト比",
        fit: "フィット",
        
        // Spacing
        page_width: "ページ幅",
        page_width_small: "ページ幅（小）",
        gutter_desktop: "デスクトップガター",
        gutter_mobile: "モバイルガター",
        desktop_vertical_spacing: "デスクトップ垂直間隔",
        mobile_vertical_spacing: "モバイル垂直間隔",
        
        // Breakpoints
        breakpoint_xs: "ブレークポイント XS",
        breakpoint_sm: "ブレークポイント SM",
        breakpoint_md: "ブレークポイント MD",
        
        // Map
        search_on_move: "移動時に検索",
        scroll_to_zoom: "スクロールでズーム",
        
        // Landing page
        sidebar_width: "サイドバー幅",
        sidebar_min_height: "サイドバー最小高さ",
        marker_image_src: "マーカー画像ソース",
        show_filter_descriptions: "フィルター説明を表示",
        
        // Location page
        tag_groups_to_display: "表示するタググループ",
        tag_groups_to_display_as_icons: "アイコンとして表示するタググループ",
        show_related_locations: "関連店舗を表示",
        
        // Locations
        hide_regions: "地域を非表示"
      },
              categories: {
          colors: "色",
          typography: "タイポグラフィ",
          buttons: "ボタン",
          images: "画像",
          spacing: "間隔",
          breakpoints: "ブレークポイント",
          map: "マップ",
          landing_page: "ランディングページ",
          location_page: "店舗ページ",
          locations: "店舗"
        }
    },
    navigation: {
      sublimeTheme: "Sublimeテーマ",
      settings: "設定",
      language: "言語",
      templates: "テンプレート",
      changeTheme: "テーマを変更",
      viewDirectory: "ディレクトリを表示",
      viewLandingPage: "ランディングページを表示"
    },
    card: {
      lastUpdated: "最終更新",
      view: "表示",
      customize: "カスタマイズ",
      publish: "公開",
      actions: "アクション"
    }
  },

  // Analytics section
  analytics: {
    title: "分析",
    timePeriods: {
      last7days: "過去7日間",
      last30days: "過去30日間"
    },
    comparison: {
      compareToPrevious: "前の期間と比較",
      stopComparing: "前の期間との比較を停止"
    },
    sections: {
      searchLocations: "店舗を検索"
    },
    cards: {
      sessions: "セッション",
      topSearches: "トップ検索",
      topLandingPageType: "トップランディングページタイプ",
      topPageViewsBySession: "セッション別トップページビュー",
      topLocations: "トップ店舗",
      topReferrers: "トップリファラー",
      searches: "検索",
      topLandingPagesBySession: "セッション別トップランディングページ"
    },
    chartLabels: {
      desktop: "デスクトップ"
    }
  },

}; 